import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  href?: string;
}

const Breadcrumbs = ({ items }: { items: Crumb[] }) => (
  <nav aria-label="面包屑导航" className="text-sm">
    <ol className="flex flex-wrap items-center gap-2 text-foreground-500">
      {items.map((item, index) => (
        <li key={`${item.label}-${index}`} className="flex items-center gap-2">
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-600 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-medium">{item.label}</span>
          )}
          {index < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-foreground-300" />
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs;